import request from 'assets/js/http';

//获取未提交会议纪要列表
export function getNoSummaryList(data) {
  let url = 'meetingProject/getNoSummaryList';
  return request({
    url,
    method: 'post',
    data
  });
}

// 项目公司-详情页
export function saveProject(data) {
  let url = 'company/addOrEdit';
  for (let key in data) {
    if (!data[key]) {
      delete data[key];
    }
  }
  return request({
    url,
    method: 'post',
    data
  });
}
// 项目公司-详情页
export function delProject(companyId) {
  return request({
    url: '/company/delete',
    method: 'post',
    data: {
      companyId
    }
  });
}
// 项目公司-详情页
export function getDetail(id, errorToast = true) {
  return request({
    url: '/company/getDetail',
    method: 'post',
    data: {
      id
    },
    errorToast
  });
}
// 阶段-列表
export function getSector() {
  return request({
    url: '/sector/list',
    method: 'post',
    data: {}
  });
}
export function getCompanyList(data) {
  return request({
    url: '/company/listView',
    method: 'post',
    data
  });
}
export function getCompanyListByState(data) {
  return request({
    url: '/company/list',
    method: 'post',
    data
  });
}
// 文件类型列表
export function getFileList() {
  return request({
    url: '/fileType/list',
    method: 'post',
    data: {}
  });
}
// 项目-文件-获取默认权限
export function getPermissionUsers(data) {
  return request({
    url: '/companyFile/getPermissionUsers',
    method: 'post',
    data
  });
}
// 项目-文件-保存权限(默认/自定义)
export function editAuthType(data) {
  return request({
    url: '/companyFile/editAuthType',
    method: 'post',
    data
  });
}
// 项目-文件-保存权限(默认/自定义)
export function setPermissionUsers(data) {
  return request({
    url: '/companyFile/setPermissionUsers',
    method: 'post',
    data
  });
}
// 项目-文件-保存权限(默认/自定义)
export function recentUpload(data) {
  return request({
    url: '/companyFile/recentUpload',
    method: 'post',
    data
  });
}
// 项目-文件-列表
export function getCompanyFile(data) {
  return request({
    url: '/companyFile/list',
    method: 'post',
    data
  });
}
// 项目详情-项目管理-修改阶段
export function changeStateId(data) {
  return request({
    url: '/company/changeStateId',
    method: 'post',
    data
  });
}
// 项目-文件-重命名
export function editFileName(data) {
  return request({
    url: '/companyFile/rename',
    method: 'post',
    data
  });
}
// 项目-文件-删除
export function deleteFile(companyFileId) {
  return request({
    url: '/companyFile/delete',
    method: 'post',
    data: {
      companyFileId
    }
  });
}
//
export function checkFeishuLinkPermission(data) {
  return request({
    url: '/companyFile/checkFeishuLinkPermission',
    method: 'post',
    data
  });
}
// 会议管理-列表
export function getMeeting(data) {
  return request({
    url: '/meetingProject/list',
    method: 'post',
    data
  });
}
// vote管理-列表-待调试
/**
 * projectId: 1
 */
export function getVoteList(data) {
  return request({
    url: '/projectVote/getVoteList',
    method: 'post',
    data
  });
}
// 最近浏览的公司
export function recentView() {
  return request({
    url: '/company/recentView',
    method: 'post',
    data: {}
  });
}
// 搜索第三方公司
export function searchThirdCompany(keyword) {
  return request({
    url: '/thirdsource/search',
    method: 'post',
    data: {
      keyword
    }
  });
}
export function thirdsourceBind(data) {
  return request({
    url: '/thirdsource/bind',
    method: 'post',
    data
  });
}
export function thirdsourceBindSync(data) {
  return request({
    url: '/thirdsource/bindCompany',
    method: 'post',
    data
  });
}
// 判断公司是否重复
export function judgeDuplication(name, fullName) {
  return request({
    url: '/company/exists',
    method: 'post',
    data: {
      name,
      fullName
    }
  });
}
// 查询第三方公司工商信息
export function getGongshangInfo(data) {
  return request({
    url: '/thirdsource/getGongshangInfo',
    method: 'post',
    data
  });
}
// 解绑第三方公司
export function unbindThirdCompany(companyId) {
  return request({
    url: '/thirdsource/unbind',
    method: 'post',
    data: {
      companyId
    }
  });
}
// 获取上会申请checklist
export function getChecklist(data) {
  return request({
    url: '/meetingProject/getCheckList',
    method: 'post',
    data
  });
}
// 撤销会议
export function cancelMeeting(data) {
  return request({
    url: '/meetingProject/recall',
    method: 'post',
    data
  });
}

export function interactRequest(data) {
  return request({
    url: '/like/manage',
    method: 'post',
    data
  });
}

//编辑录音标签
export function audioTagEdit(data) {
  return request({
    url: 'audio/tagModify',
    method: 'post',
    data
  });
}

// 会议录音详情
export function audioMeetingDetail(data) {
  return request({
    url: '/meetingProject/audioDetail',
    method: 'post',
    data
  });
}

// 会议录音详情
export function audioMeetingContent(data) {
  return request({
    url: '/audio/contentQuery',
    method: 'post',
    data
  });
}

//修改会议录音内容
export function audioContentModify(data) {
  return request({
    url: '/audio/contentModify',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// 查询录音日志
export function audioLogQuery(data) {
  return request({
    url: 'audio/logQuery',
    method: 'post',
    data
  });
}

// 修改录音日志
export function audioLogManage(data) {
  return request({
    url: '/audio/logManage',
    method: 'post',
    data
  });
}

//获取人工纪要的重点，对应录音片段
export function getSummaryPoints(data) {
  return request({
    url: '/audio/queryMatch',
    method: 'post',
    data
  });
}

//重新生成录音的文字内容
export function reproduceAudioContent(data) {
  return request({
    url: 'audio/rebuildContent',
    method: 'post',
    data
  });
}

//自动匹配
export function autoMatch(data) {
  return request({
    url: '/audio/match',
    method: 'post',
    data
  });
}

//查询某个meeting中是否有正在上传的录音
export function queryUploadStatus(data) {
  return request({
    url: '/audio/queryUploadStatus',
    method: 'post',
    data
  });
}

export function portfolioQuery(data, errorToast = true) {
  return request({
    url: '/company/portfolioQuery',
    method: 'post',
    data,
    errorToast
  });
}

export function savePortfolio(data) {
  return request({
    url: '/company/portfolioManage',
    method: 'post',
    data
  });
}

export function locationListQuery(data) {
  return request({
    url: '/company/locationListQuery',
    method: 'post',
    data
  });
}

export function refreshLocationList(data) {
  return request({
    url: '/company/refreshLocationList',
    method: 'post',
    data
  });
}

//查询项目对应的法务系统id
export function ifLegalCompanyExist(data) {
  return request({
    url: '/company/ifLegalCompanyExist',
    method: 'post',
    data
  });
}

//法务系统新建项目
export function legalCompanyManage(data) {
  return request({
    url: '/company/legalCompanyManage',
    method: 'post',
    data
  });
}

export function historyStage(data) {
  return request({
    url: '/company/historyStage',
    method: 'post',
    data
  });
}
//新建项目
export function companyAdd(data) {
  return request({
    url: '/company/add',
    method: 'post',
    data
  });
}

//编辑基础信息
export function editBase(data) {
  return request({
    url: '/company/editBase',
    method: 'post',
    data
  });
}

//编辑保密信息
export function editSecret(data) {
  return request({
    url: '/company/editSecret',
    method: 'post',
    data
  });
}

//编辑项目组信息
export function editMember(data) {
  return request({
    url: '/company/editMember',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// 项目节点查询
export function nodeQuery(data) {
  return request({
    url: '/company/nodeList',
    method: 'post',
    data
  });
}

// 项目操作-NDA/TS/dropTS/Follow on/放弃项目
export function companyOperate(data) {
  return request({
    url: '/company/operate',
    method: 'post',
    data
  });
}

// 项目组变更历史查询
export function memberLog(data) {
  return request({
    url: '/company/memberLog',
    method: 'post',
    data
  });
}

// 是否可进项目
export function ifCanAccess(data) {
  return request({
    url: '/company/ifCanAccess',
    method: 'post',
    data
  });
}

//绑定项目到码会系统
export function bindToCodeClass(data) {
  return request({
    url: '/company/bindToMahui',
    method: 'post',
    data
  });
}

// 新建轮次
export function addRound(data) {
  return request({
    url: '/projectRound/add',
    method: 'post',
    data
  });
}

// 编辑轮次
export function editRound(data) {
  return request({
    url: '/projectRound/edit',
    method: 'post',
    data
  });
}

// 删除轮次
export function deleteRound(data) {
  return request({
    url: '/projectRound/delete',
    method: 'post',
    data
  });
}

// 查询百川决策时间、交割时间
export function queryCompanyStageDate(data) {
  return request({
    url: '/projectRound/queryCompanyStageDate',
    method: 'post',
    data
  });
}

// 查询项目会议录音权限
export const audioPermission = data => {
  return request({
    url: '/meetingProject/audioPermission',
    method: 'POST',
    data: data
  });
};

//查询项目DLDM
export const queryDlDmUser = data => {
  return request({
    url: '/company/queryDlDmUser',
    method: 'POST',
    data: data
  });
};

//权限申请
export const applyPermission = data => {
  return request({
    url: '/approve/applyPermission',
    method: 'POST',
    data: data
  });
};

//阶段列表
export const stateList = data => {
  return request({
    url: '/state/list',
    method: 'POST',
    data: data
  });
};

//权限申请状态
export const ifApplyPermission = data => {
  return request({
    url: '/approve/ifApplyPermission',
    method: 'POST',
    data: data
  });
};

//查询最新财报解析季度
export const getFinanceQuarterNewest = data => {
  return request({
    url: '/gather/getFinanceQuarterNewest',
    method: 'POST',
    data: data
  });
};
